export default class Cache {
  static cache: { [index: string]: any };
  static initCache() {
    this.cache = {};
  }

  static addToCache(key: string, object: any) {
    if (this.cache === undefined) {
      this.initCache();
    }

    this.cache[key.toLowerCase()] = object;
    //console.log("cache", this.cache)
  }

  static retrieveFromCache(key: string) {
    //console.log('retrieve from cache', key)
    if (this.cache === undefined) {
      this.initCache();
    }
    return this.cache[key] !== undefined ? this.cache[key] : null;
  }

  static removeFromCache(key: string) {
    if (this.cache === undefined) {
      return;
    }

    delete this.cache[key];
  }
}
